import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { CoreModule } from '../core/core.module';
import { SchedulerComponent } from './pages/scheduler/scheduler.component';
import { SchedulerHoursComponent } from './pages/scheduler-hours/scheduler-hours.component';

const routes: Routes = [
  { path: 'workshop/scheduler', component: SchedulerComponent, canActivate: [AuthGuard] },
  { path: 'workshop/scheduler/hours', component: SchedulerHoursComponent, canActivate: [AuthGuard] },
];

/** Workshop scheduler (docs/superpowers/specs/2026-10-21-workshop-scheduler-design.md). */
@NgModule({
  declarations: [SchedulerComponent, SchedulerHoursComponent],
  imports: [CommonModule, FormsModule, CoreModule, RouterModule.forChild(routes)],
})
export class WorkshopSchedulerModule { }
